import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const MobileSidebar = ({ sidebaritems, type }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeMenu, setActiveMenu] = useState(null);
  const [selectedSubMenu, setSelectedSubMenu] = useState(null);

  useEffect(() => {
    setActiveMenu(null);
    sidebaritems.forEach((nav, index) => {
      if (location.pathname.startsWith(nav.path)) {
        setActiveMenu(index);
        nav.subNav.forEach((sub) => {
          const fullPath = nav.path + sub.path;
          if (location.pathname === fullPath) {
            setSelectedSubMenu(fullPath);
          }
        });
      }
    });
  }, [location.pathname, sidebaritems]);

  const menuClickHandler = (index, nav) => {
    setActiveMenu(index);
    if (!nav.subNav.length) {
      navigate(nav.path);
      setSelectedSubMenu(nav.path);
    } else {
      const fullPath = nav.path + nav.subNav[0].path;
      navigate(fullPath);
      setSelectedSubMenu(fullPath);
    }
  };

  return (
    <div className="min-w-[240px] w-full h-full text-title-sm-regular  bg-primary-100  border-t border-white flex items-center  p-2 gap-2 justify-between ">
      {sidebaritems.map((nav, index) => {
        const active = activeMenu === index;
        return (
          <button
            key={index}
            className={`flex-center py-2 px-1 w-full rounded-lg  shadow-xl hover:bg-primary-90 cursor-pointer ${
              active && "bg-primary-80   "
            }`}
            onClick={() => menuClickHandler(index, nav)}
            aria-expanded={active}
            aria-controls={`submenu-${index}`}
          >
            <div className={active ? " " : "  "}>
              <div className="flex gap-2">
                {nav.icon ? (
                  <div className="flex flex-col items-center">
                    <img width={20} height={20} src={nav.icon} alt="*" />
                    <p className="text-white text-[10px]">{nav.title}</p>
                  </div>
                ) : null}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default MobileSidebar;
